<template>

  <Transition mode="out-in">

    <div v-if="this.step == 1" class="d-flex flex-column justify-content-center align-items-stretch h-100">

      <form class="auth-form d-flex flex-column align-content-between h-100" @submit.prevent="submitUserEmail">
        <div class="form-group" :class="{ 'is-invalid': inputHasValidationError('email') }">
          <input type="email" class="form-control form-control-lg" v-model="email" placeholder="Enter your email address" autocomplete="on">
        </div>

        <div class="auth-form-footer d-flex justify-content-end">
          <button type="submit" class="btn btn-primary" :disabled="!stepOneSubmissionEnabled" @click="submitUserEmail">Next</button>
        </div>

      </form>

    </div>


    <div v-else-if="this.step == 2 && hasSelectedAuthProvider !== true" class="d-flex flex-column justify-content-center align-items-stretch h-100">
      <form class="auth-form d-flex flex-column align-content-between h-100" @submit.prevent="preventFormSubmissionOnEnterKeypress">

        <button type="button" class="auth-sso-selection btn btn-gray btn-lg mb-1 d-flex flex-row" @click.prevent="resetForm">
          <div class="auth-button-image">
            <i class="bi bi-arrow-left-circle"></i>
          </div>
          Use a different email address
        </button>

        <div class="auth-button-divider mt-2 mb-3"></div>


          <template v-for="provider in authProviders">
            <button v-if="provider.provider == 'PASSWORD'" type="button" class="auth-sso-selection btn btn-primary btn-lg mb-3 d-flex flex-row" @click.prevent="selectAuthProvider(provider)">
              <div class="auth-button-image">
                <i class="bi bi-lock"></i>
              </div>
              {{ getProviderButtonText(provider) }}
            </button>
            <button v-if="provider.provider == 'MICROSOFT_ENTRA_IDP'" class="auth-sso-selection btn btn-primary btn-lg mb-3 d-flex flex-row" @click.prevent="selectAuthProvider(provider)">
              <div class="auth-button-image">
                <i class="bi bi-windows"></i>
              </div>
              {{ getProviderButtonText(provider) }}
            </button>
          </template>
      </form>
    </div>



    <div v-else-if="this.step == 2 && hasSelectedAuthProvider == true" class="d-flex flex-column justify-content-center align-items-stretch h-100">
      <form class="auth-form d-flex flex-column align-content-between h-100" @submit.prevent="submitLoginAttempt">
        <div class="form-group" :class="{ 'is-invalid': inputHasValidationError('password') }">
          <input type="password" class="form-control form-control-lg" v-model="password" placeholder="Enter your password" autocomplete="on">
          <router-link
            :to="{ name: 'login.forgot', query: {email: this.email} }"
            class="float-right"
            tabindex="5"
          >
            Forgot my password
          </router-link>
        </div>
        <div class="auth-form-footer d-flex justify-content-end">
          <button type="button" class="btn btn-primary" :disabled="!stepTwoSubmissionEnabled" @click="submitLoginAttempt">Next</button>
        </div>
      </form>
    </div>



<!--    <div v-else-if="this.step == 2 && hasSelectedAuthProvider == true" class="d-flex flex-row flex-fill justify-content-center align-items-center">-->
<!--      <div class="d-flex flex-column w-50 mw-50 align-items-center" style="height: 100%;">-->

<!--        &lt;!&ndash; PASSWORD PROVIDER &ndash;&gt;-->
<!--        <h5 class="text-center pb-4 text-primary font-weight-normal">Signing in as: <b>{{ authData.email }}</b></h5>-->

<!--        <form class="auth-form d-flex flex-column align-content-between h-100">-->

<!--          <div class="form-group">-->
<!--            <input type="password" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-lg" v-model="password" placeholder="password">-->
<!--          </div>-->

<!--          <div class="auth-form-footer d-flex justify-content-between">-->
<!--            <button type="button" class="btn btn-primary btn-lg" @click="this.$emit('reset-auth-provider-selection')">Back</button>-->
<!--            <button type="button" class="btn btn-primary" @click="submitLoginAttempt">Next</button>-->
<!--          </div>-->
<!--          -->
<!--        </form>-->

<!--      </div>-->
<!--    </div>-->

  </Transition>

</template>

<script>

import { helpers, required, email } from '@vuelidate/validators'
import { useVuelidate } from "@vuelidate/core"


export default {

  emits: [
    'reset-form',
    'update-step',
    'set-loading-state',
    'submit-user-email',
    'select-auth-provider',
    'clear-selected-auth-provider',
    'reset-auth-provider-selection',
    'submit-password-login'
  ],

  props: {
    step: {
      type: Number,
      required: true,
      default: 1,
    },
    authData: {
      type: Object,
      required: false
    },
    authProviders: {
      type: Array,
      required: false
    },
    selectedAuthProvider: {
      type: Object,
      required: false
    },
  },

  data() {
    return {
      email: '',
      password: ''
    }
  },

  computed: {
    hasSelectedAuthProvider: function() {
      return this.lodash.isNil(this.selectedAuthProvider) !== true;
    },
    selectedAuthProviderName: function() {
      if (!this.lodash.isNil(this.selectedAuthProvider)) {
        return this.selectedAuthProvider.provider;
      }
    },
    stepOneSubmissionEnabled: function() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.email);
    },
    stepTwoSubmissionEnabled: function() {
      return this.password.length > 6;
    },
  },

  setup () {
    return { v$: useVuelidate() }
  },

  validations () {
    return {
      email: {
        required,
        email
      },
      password: {
        required,
        $lazy: true
      }
    }
  },

  beforeMount() {
    //
  },
  mounted() {
    //
  },
  methods: {

    preventFormSubmissionOnEnterKeypress()
    {
      return false;
    },

    resetForm() {
      this.email = '';
      this.$emit('reset-form')
    },

    inputHasValidationError(fieldName) {
      if (this[fieldName].length > 0) {
        return this.v$[fieldName].$error
      }
    },

    getProviderButtonImage(provider) {
      let providerName = provider.provider;
      if (providerName == "PASSWORD") {
        return "@/assets/images/sso-logos/sso-microsoft.svg";
      }
      if (providerName == "MICROSOFT_ENTRA_IDP") {
        return "@/assets/images/sso-logos/sso-microsoft.svg";
      }
    },

    getProviderButtonText(provider) {
      let providerName = provider.provider;
      if (providerName == "PASSWORD") {
        return "Sign in using your Password";
      }
      if (providerName == "MICROSOFT_ENTRA_IDP") {
        return "Sign in with Microsoft";
      }
    },

    requiresAuthProviderSelection() {
      let res = this.lodash.isNil(this.selectedAuthProvider);
      console.log("requiresAuthProviderSelection: " + res)
      return res
    },

    updateStep() {
      let newStep;
      if (this.step == 1) {
        newStep = 2
      } else {
        newStep = 1
      }
      this.$emit('update-step', newStep);
    },

    async submitUserEmail() {

      this.$emit('set-loading-state', true)

      // Validate user email
      const isValid = await this.v$.$validate()

      // Toast message for failed validation rule: required
      if (this.v$.email.required.$invalid) {
        this.$toast.error("Email address is required")
        return;
      }
      // Toast message for failed validation rule: email
      if (this.v$.email.email.$invalid) {
        this.$toast.error("Please enter a valid email address")
        return;
      }
      this.$emit('submit-user-email', this.email)
    },

    selectAuthProvider(provider) {
      this.$emit('select-auth-provider', provider)
    },

    submitLoginAttempt() {
      let payload = {
        email: this.email,
        password: this.password
      }
      this.$emit('submit-password-login', payload)
    }

  },

}
</script>

<style>

.login-bg {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background: #f0f4f9;
  z-index: -1;
}

.login-box {
  min-height: 35%;
  min-width: 75%;
  background: white;
  border: 1px solid #e3e3e3;
}

/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}


</style>
